import type { Member, ServerView } from '@hearth/shared';
import { Avatar } from './Avatar';
import { may } from './serverWords';

// Who can play on a server (M10.12): the owner first, then members by when they joined. Owners
// remove members; a member can leave. Names and pictures only: never emails.

export const memberName = (m: Pick<Member, 'name'>) => m.name ?? 'A friend';

/** The members panel, given what's loaded (no fetching: easy to test). `members` undefined = loading. */
export function MembersPanel(props: {
  server: ServerView;
  members: Member[] | undefined;
  /** The signed-in person: "(you)" beside their name. */
  meId: string;
  busy: boolean;
  onRemove: (member: Member) => void;
  onLeave: () => void;
}) {
  const { server, members, meId, busy, onRemove, onLeave } = props;
  const removes = may(server, 'removeMember');
  return (
    <section className="panel panel-members">
      <h2>Who can play here</h2>
      {!members ? (
        <p className="quiet" aria-live="polite">Loading…</p>
      ) : (
        <ul className="people">
          {members.map((m) => (
            <li key={m.userId}>
              <Avatar name={memberName(m)} picture={m.picture} />
              <span className="person-name">
                {memberName(m)}
                {m.userId === meId && <span className="quiet"> (you)</span>}
              </span>
              <span className="quiet person-role">{m.role === 'owner' ? 'Owner' : 'Member'}</span>
              {removes && m.role === 'member' && m.userId !== meId && (
                <button className="quiet-btn quiet-danger" type="button" disabled={busy} aria-label={`Remove ${memberName(m)}`} onClick={() => onRemove(m)}>
                  Remove
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
      {server.role === 'member' && (
        <div className="leave">
          <span className="quiet">Done playing here?</span>
          <button className="btn btn-danger-outline" type="button" disabled={busy} onClick={onLeave}>Leave this server</button>
        </div>
      )}
    </section>
  );
}
